// extracted by css-extract-rspack-plugin
export default {"counter":"_4da6444d"};